/* Vedicflora discount badge: appends "X% OFF" in bold red right after the
 * sale price on every product card / PDP. Reads the strikethrough <s> as the
 * regular (compare-at) price.
 */
(function(){
  function parsePrice(text){
    if (!text) return NaN;
    var n = parseFloat(text.replace(/[^\d.]/g, ''));
    return isFinite(n) ? n : NaN;
  }

  function update() {
    document.querySelectorAll('.price--on-sale').forEach(function(priceBlock){
      if (priceBlock.dataset.vfDisc === '1') return;

      // Regular price = the strikethrough (Dawn renders it inside <s>)
      var regEl = priceBlock.querySelector('s .price-item--regular, s.price-item--regular');
      // Sale price = .price-item--sale or --last
      var saleEl = priceBlock.querySelector('.price-item--sale, .price-item--last');
      var reg = parsePrice(regEl ? regEl.textContent : '');
      var sale = parsePrice(saleEl ? saleEl.textContent : '');
      if (!reg || !sale || sale >= reg) return;

      var pct = Math.round((1 - sale / reg) * 100);
      if (pct < 1) return;

      var badge = document.createElement('span');
      badge.className = 'vf-pct-off';
      badge.textContent = pct + '% OFF';
      badge.style.cssText = [
        'display:inline-block',
        'margin-left:8px',
        'padding:1px 6px',
        'font-size:0.85em',
        'font-weight:700',
        'letter-spacing:0.3px',
        'color:#ff6b6b',
        'border:1px solid #ff6b6b',
        'border-radius:3px',
        'vertical-align:middle',
        'line-height:1.4',
      ].join(';');

      // Insert immediately after the sale-price element
      if (saleEl && saleEl.parentNode) {
        saleEl.insertAdjacentElement('afterend', badge);
        priceBlock.dataset.vfDisc = '1';
      }
    });
  }

  function init(){
    update();
    var mo = new MutationObserver(function(){
      clearTimeout(window.__vfDiscTimer);
      window.__vfDiscTimer = setTimeout(update, 100);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
